import { put, call } from 'redux-saga/effects';
import swal from 'sweetalert';
import { LOGOUT } from '../containers/Main/actions';

export function* handleApiError(error, failureActionType) {
  const statusCode = error.response?.status;
  const errorMessage =
    error.response?.data?.message || error.message || 'Something went wrong';

  if (statusCode === 403) {
    yield put({ type: LOGOUT });
    yield call([window.location, 'replace'], '/login');
    return;
  }

  yield put({ type: failureActionType, payload: errorMessage });
  yield call(swal, 'Error', errorMessage, 'error');
}
